export default __webpack_public_path__ + "media/zurb/img/events/soapbox/benparr-96251853ed386c555cf2fdb7f172b659.png";